import script from "./ImprintsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ImprintsTable.vue?vue&type=script&setup=true&lang=js"

import "./ImprintsTable.vue?vue&type=style&index=0&id=6f6e4c67&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f6e4c67"]])

export default __exports__